import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as n, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconShieldOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], f = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M.646.646a.5.5 0 0 1 .708 0L2.71 2.004l.016.015L9.16 8.454a.575.575 0 0 1 .005.005l2.188 2.187a.5.5 0 0 1-.708.708L8.82 9.527a10.645 10.645 0 0 1-2.587 1.915.5.5 0 0 1-.457.005L6 11l-.224.447h-.001l-.004-.002-.01-.006-.038-.02a10.362 10.362 0 0 1-.613-.355c-.39-.244-.914-.603-1.44-1.063C2.64 9.101 1.5 7.723 1.5 6V2.5a.5.5 0 0 1 .058-.235l-.912-.911a.5.5 0 0 1 0-.708ZM2.5 3.207V6c0 1.277.86 2.4 1.83 3.249A10.341 10.341 0 0 0 6 10.43a9.643 9.643 0 0 0 2.113-1.61L2.5 3.206ZM5.825.532a.5.5 0 0 1 .35 0l4 1.5a.5.5 0 0 1 .325.468v3.503a3.952 3.952 0 0 1-.178 1.145.5.5 0 1 1-.955-.296 2.95 2.95 0 0 0 .133-.854V2.846L6 1.534l-1.405.524a.5.5 0 1 1-.35-.936l1.58-.59Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  f
], p = ["id"], m = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  m
];
function v(e, I, l, L, S, t) {
  return n(), r("svg", {
    "aria-label": l.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--shield-off"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Shield Off",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, h, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, p)
    ])
  ], 10, _);
}
const w = /* @__PURE__ */ s(c, [["render", v]]);
export {
  w as default
};
//# sourceMappingURL=shield-off.js.map
